import React from "react";

const ServiceNowSummitDC = () => {
  const EVENT_URL = "https://example.com/event-details"; // replace with actual event link

  return (
    <section className="max-w-3xl mx-auto p-6 bg-white rounded-2xl shadow-lg mt-8">
      <header className="mb-4">
        <h1 className="text-2xl md:text-3xl font-semibold">
          ServiceNow Summit D.C. - Agentic AI Service Desk Automation: Live Demo
        </h1>
        <p className="mt-2 text-sm text-gray-500">
          Tiara is a proud Diamond sponsor for this event.
        </p>
      </header>

      <div className="space-y-4">
        <p>
          Join us at <strong>ServiceNow AI Summit 2025</strong> series in
          Washington, D.C. to see a live demo of Voice Agent driven automation
          of ITSM/CSM/HRSD service fulfillment processes (for example, Password
          Reset) using <em>Live Voice Orchestration</em>.
        </p>

        <div className="rounded-lg bg-gray-50 p-4 border border-gray-100">
          <p className="text-sm">
            <strong>Venue:</strong> Marquis Marriott Washington DC
          </p>
          <p className="text-sm mt-1">
            <strong>Date &amp; Time:</strong> Tuesday, September 23, 2025 — 12:45
            to 1:15 PM EST
          </p>
          <p className="text-sm mt-1">
            <strong>Room:</strong> Liberty Salon
          </p>
        </div>

        <p>
          Registration is closed and waitlisted. For event details please visit{" "}
          <a
            href={EVENT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            here
          </a>
          .
        </p>

        <div className="mt-4 flex items-center gap-3">
          <span className="inline-block px-3 py-1 text-sm bg-gradient-to-r from-green-100 to-blue-50 rounded-full border border-green-200">
            Diamond Sponsor
          </span>
        </div>

        <footer className="mt-6 text-xs text-gray-400">
          Replace <code>EVENT_URL</code> with the real link to the event. This
          component uses Tailwind classes — drop it into a project that already
          has Tailwind configured.
        </footer>
      </div>
    </section>
  );
};

export default ServiceNowSummitDC;
